import React from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: string;
}

interface State {
  hasError: boolean;
  error: string;
}

export default class FeatureErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error.message };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center py-16">
          <div className="bg-white p-8 rounded-xl shadow-sm border border-red-100 max-w-sm text-center">
            <h2 className="text-lg font-semibold text-red-600 mb-2">
              {this.props.fallback || 'Something went wrong'}
            </h2>
            <p className="text-gray-500 text-sm mb-4">{this.state.error}</p>
            <button
              onClick={() => this.setState({ hasError: false, error: '' })}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700 transition-colors"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
